import React, { memo } from 'react';
import { format } from 'date-fns';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import { REPORT_CURRENCIES, DATE_TIME_FORMAT } from '../../../constants';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';
import { useFormatDateByLocale } from '../../../util/hooks/useFormatDateByLocale';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingMaturity({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const {
    currency,
    asOfDate1,
    asOfDate2,
    asOfDate1Custom,
    asOfDate2Custom,
    runByCalendarYear,
    runByFiscalYear,
    runWithPriorMonthSpotRate,
    runWithSpotRate,
  } = reportSnapshot;
  const formattedAsOfDate = useFormatDateByLocale(asOfDate2);

  return (
    <>
      <Styled.ReportSettingItem hasSecondColumn={true}>
        <Icon name="calendar" />
        <GStyled.Text>Start Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {asOfDate1Custom
            ? `${asOfDate1Custom.month}/${asOfDate1Custom.year}`
            : format(asOfDate1, DATE_TIME_FORMAT.MONTH_YEAR)}
        </GStyled.Text>
        <GStyled.Text>End Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {asOfDate2Custom
            ? `${asOfDate2Custom.month}/${asOfDate2Custom.year}`
            : formattedAsOfDate}
        </GStyled.Text>
      </Styled.ReportSettingItem>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
      <Styled.ReportSettingItem hasSecondColumn={true}>
        <Icon name="gear" />
        <GStyled.Text>Run by</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {runByCalendarYear
            ? 'Calendar Year'
            : runByFiscalYear
            ? 'Fiscal Year'
            : 'Start Date'}
        </GStyled.Text>
        <GStyled.Text>Run With</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {runWithPriorMonthSpotRate
            ? 'Prior Month Spot Rate'
            : runWithSpotRate
            ? 'Spot Rate'
            : 'Average Rate'}
        </GStyled.Text>
      </Styled.ReportSettingItem>
      <Styled.ReportSettingItem>
        <Icon name="currency" />
        <GStyled.Text>Currency</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {REPORT_CURRENCIES[currency].label}
        </GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingMaturity);
